// src/components/virtual-agent-control-exit-survey/virtual-agent-control-exit-survey.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  query VirtualAgentControlExitSurveyQuery($context: ContextInput!, $propertyId: String!) {\n    propertyInfo(context: $context, propertyId: $propertyId) {\n      id\n      summary {\n        lodgingChatbot {\n          botNoLabel\n          botYesLabel\n          feedbackContentLabel\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  query VirtualAgentControlExitSurveyFeedbackQuery($context: ContextInput!, $propertyId: String!) {\n    propertyInfo(context: $context, propertyId: $propertyId) {\n      id\n      summary {\n        lodgingChatbot {\n          feedbackFormTitleLabel\n          feedbackFormContentLabel\n          feedbackFormLabel\n          botSkipLabel\n          feedbackFormSubmitLabel\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
import React from "react";
import { gql, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { UitkSecondaryButton } from "uitk-react-button";
import { UitkSheet } from "uitk-react-sheet";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkText } from "uitk-react-text";
// src/components/virtual-agent-control-exit-survey/analytics.ts
var chatbotSchema = function(chatbotEntryPoint, chatbotName, propertyId) {
    return {
        schemaName: "chatbot",
        messageContent: {
            chatbotEntryPoint: chatbotEntryPoint,
            chatbotName: chatbotName,
            propertyId: propertyId
        }
    };
};
var chatbotHelpfulSchema = function(chatbotEntryPoint, chatbotName, helpful, propertyId) {
    return {
        schemaName: "chatbot",
        messageContent: {
            chatbotEntryPoint: chatbotEntryPoint,
            chatbotName: chatbotName,
            helpful: helpful,
            propertyId: propertyId
        }
    };
};
// src/components/virtual-agent-control-exit-survey/virtual-agent-control-exit-survey.tsx
var __Query = gql(_templateObject());
var VirtualAgentControlExitSurvey = function(props) {
    var _data_propertyInfo_summary;
    var inputs = props.inputs, skipSsr = props.skipSsr, chatbotEntryPoint = props.chatbotEntryPoint, chatbotName = props.chatbotName, timeoutMs = props.timeoutMs, onDismiss = props.onDismiss;
    var propertyId = inputs.propertyId;
    var context = useBexApi().context;
    var track = useClickTracker();
    var variables = _objectSpreadProps(_objectSpread({}, inputs || {}), {
        context: context
    });
    React.useEffect(function() {
        var timeout = setTimeout(function() {
            onDismiss();
        }, timeoutMs);
        var message = chatbotSchema(chatbotEntryPoint, chatbotName, propertyId);
        track("Customer.VirtualAgentControl.ExitSurvey", "chatbot_exit_survey.presented", void 0, [
            message
        ]);
        return function() {
            track("Customer.VirtualAgentControl.ExitSurvey", "chatbot_exit_survey.hidden", void 0, [
                message
            ]);
            clearTimeout(timeout);
        };
    }, [
        chatbotEntryPoint,
        chatbotName,
        onDismiss,
        propertyId,
        timeoutMs,
        track
    ]);
    var _useQuery = useQuery(__Query, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    var lodgingChatbot = (_data_propertyInfo_summary = data === null || data === void 0 ? void 0 : data.propertyInfo.summary) === null || _data_propertyInfo_summary === void 0 ? void 0 : _data_propertyInfo_summary.lodgingChatbot;
    if (loading || error || !data || !lodgingChatbot) {
        return null;
    }
    var botYesLabel = lodgingChatbot.botYesLabel, botNoLabel = lodgingChatbot.botNoLabel, feedbackContentLabel = lodgingChatbot.feedbackContentLabel;
    var onSubmitHelpful = function(helpful) {
        var message = chatbotHelpfulSchema(chatbotEntryPoint, chatbotName, helpful, propertyId);
        track("Customer.VirtualAgentControl.ExitSurvey", "chatbot_exit_survey.submitted", void 0, [
            message
        ]);
        onDismiss(helpful);
    };
    return /* @__PURE__ */ React.createElement(UitkSheet, {
        isVisible: true,
        type: "bottom",
        triggerRef: null
    }, /* @__PURE__ */ React.createElement(UitkSpacing, {
        padding: "three"
    }, /* @__PURE__ */ React.createElement(UitkText, null, feedbackContentLabel)), /* @__PURE__ */ React.createElement(UitkSpacing, {
        margin: "three"
    }, /* @__PURE__ */ React.createElement(UitkSecondaryButton, {
        onClick: function() {
            return onSubmitHelpful(true);
        }
    }, botYesLabel)), /* @__PURE__ */ React.createElement(UitkSpacing, {
        margin: {
            block: "three"
        }
    }, /* @__PURE__ */ React.createElement(UitkSecondaryButton, {
        onClick: function() {
            return onSubmitHelpful(false);
        }
    }, botNoLabel)));
};
VirtualAgentControlExitSurvey.displayName = "VirtualAgentControlExitSurvey";
// src/components/virtual-agent-control-exit-survey-feedback/virtual-agent-control-exit-survey-feedback.tsx
import React2 from "react";
import { gql as gql2, useQuery as useQuery2 } from "@apollo/client";
import { useBexApi as useBexApi2 } from "@shared-ui/bex-api-context";
import { UitkDialog, UitkDialogAnimationType, UitkDialogContent, UitkDialogFooter } from "uitk-react-dialog";
import { UitkTextArea } from "uitk-react-input";
import { UitkSpacing as UitkSpacing2 } from "uitk-react-spacing";
import { UitkHeading, UitkText as UitkText2 } from "uitk-react-text";
var __Query2 = gql2(_templateObject1());
var TextArea = function(textAreaProps) {
    var _React2_useState = _slicedToArray(React2.useState(""), 2), text = _React2_useState[0], setText = _React2_useState[1];
    var handleChange = function(e) {
        setText(e.target.value);
    };
    var inputRef = textAreaProps.inputRef, label = textAreaProps.label;
    return /* @__PURE__ */ React2.createElement(UitkTextArea, {
        domRef: inputRef,
        id: "survey-feedback",
        label: label !== null && label !== void 0 ? label : "",
        value: text,
        onChange: handleChange
    });
};
var VirtualAgentControlExitSurveyFeedback = function(props) {
    var _data_propertyInfo_summary;
    var inputs = props.inputs, skipSsr = props.skipSsr, onDismiss = props.onDismiss;
    var context = useBexApi2().context;
    var feedbackRef = React2.createRef();
    var variables = _objectSpreadProps(_objectSpread({}, inputs || {}), {
        context: context
    });
    var _useQuery2 = useQuery2(__Query2, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery2.data, error = _useQuery2.error, loading = _useQuery2.loading;
    var lodgingChatbot = (_data_propertyInfo_summary = data === null || data === void 0 ? void 0 : data.propertyInfo.summary) === null || _data_propertyInfo_summary === void 0 ? void 0 : _data_propertyInfo_summary.lodgingChatbot;
    if (loading || error || !data || !lodgingChatbot) {
        return null;
    }
    var feedbackFormTitleLabel = lodgingChatbot.feedbackFormTitleLabel, feedbackFormContentLabel = lodgingChatbot.feedbackFormContentLabel, feedbackFormLabel = lodgingChatbot.feedbackFormLabel, botSkipLabel = lodgingChatbot.botSkipLabel, feedbackFormSubmitLabel = lodgingChatbot.feedbackFormSubmitLabel;
    var onSubmitFeedback = function() {
        var _feedbackRef_current;
        var feedback = (_feedbackRef_current = feedbackRef.current) === null || _feedbackRef_current === void 0 ? void 0 : _feedbackRef_current.value;
        if (feedback) {}
        onDismiss();
    };
    return /* @__PURE__ */ React2.createElement(UitkDialog, {
        dialogShow: true,
        autoFocus: false,
        animation: UitkDialogAnimationType.FADE
    }, /* @__PURE__ */ React2.createElement(UitkDialogContent, {
        key: "exitSurveyFeedback"
    }, /* @__PURE__ */ React2.createElement(UitkHeading, {
        tag: "h1",
        size: 5
    }, feedbackFormTitleLabel), /* @__PURE__ */ React2.createElement(UitkSpacing2, {
        padding: {
            block: "three"
        }
    }, /* @__PURE__ */ React2.createElement(UitkText2, null, feedbackFormContentLabel)), /* @__PURE__ */ React2.createElement(TextArea, {
        inputRef: feedbackRef,
        label: feedbackFormLabel
    })), /* @__PURE__ */ React2.createElement(UitkDialogFooter, {
        key: "UitkDialogFooter",
        stacked: false,
        buttonOne: {
            onClick: onDismiss,
            text: botSkipLabel,
            type: "tertiary"
        },
        buttonTwo: {
            onClick: onSubmitFeedback,
            text: feedbackFormSubmitLabel,
            type: "primary"
        }
    }));
};
VirtualAgentControlExitSurveyFeedback.displayName = "VirtualAgentControlExitSurveyFeedback";
export { VirtualAgentControlExitSurvey, VirtualAgentControlExitSurveyFeedback };
//# sourceMappingURL=index.js.map